<template>
  <div>
   
    <ListLibroMayorGeneral :visible="visible"/>
  </div>
</template>

<script>
import api from "@/api/axios";
import ListLibroMayorGeneral from "./ListLibroMayorGeneral.vue"
export default {
  name: "ModalIngresoMes",

  props: {
   
    centro_id: {
      type: Number,
    },
    nomcta: {
      type: String,
    },
    nomcentro: {
      type: String,
    },
    datosModificacion: {
      type: Object,
    },
    modificaciones_bloqueados: {
      type: Boolean,
    },
    timestamp: {
      type: String,
    },
  },
  computed: {
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
  },
  watch: {


    timestamp: function () {
      this.recargaDatos(this.datosModificacion);
    },
  },
  methods: {
    async borralibromayor(id) {

      const formData = new FormData();
      formData.append("libromayorgeneral_id", id);
      try {
        const resp = await api.post(
          "/api/v1/libromayor/delete/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },


          }
        );

        if (resp.data.error) {
          alert(resp.data.error);

          return;
        }

        this.loading = false;

   

      } catch (error) {

        const status = error.response.status;
        const message = error.response.data?.detail;
        console.error("Error al enviar:", error);
        console.log("Código:", status);
        console.log("Mensaje:", message);

      }
    }
    ,

  


  },
  data() {
    return {
       historialLibros: [],
       visible:false
    };
    
  },
  mounted() {
 
    console.log('montar1')

  },
  components:{
    ListLibroMayorGeneral
  }
};
</script>

<style scoped></style>
